const DEFAULT_URL = window.location.origin

export const DEFAULT_ASSETS_ROOT = DEFAULT_URL + '/assets/'
